import { GET_EMPLOYEES_SUCCESS } from "./employees.types";

const initialState = {
  employeesList: null,
};

export const employeesReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_EMPLOYEES_SUCCESS:
      return {
        ...state,
        employeesList: action.payload,
      };

    default:
      return state;
  }
};
